import { render, staticRenderFns } from "./InfoMap.vue?vue&type=template&id=4af160a6&scoped=true"
import script from "./InfoMap.vue?vue&type=script&lang=js"
export * from "./InfoMap.vue?vue&type=script&lang=js"
import style0 from "./InfoMap.vue?vue&type=style&index=0&id=4af160a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af160a6",
  null
  
)

export default component.exports